module.exports = __webpack_public_path__ + "img/城市运行管理系统V1.0.f5120d2c.jpg";